import { Flex, Popover } from 'antd';
import Button from 'components/Button';
import React, { PropsWithChildren } from 'react';
import { KPI_PERCENTAGES_FOR_TARGETS } from 'screens/season-overview/constants';
import { KPI } from 'screens/season-overview/types';
import { takeActionBasedOnCurrentProgressKPI } from 'screens/season-overview/util';
import { formatCurrencyShortened } from 'utils/helpers';

type SalesTargetPopoverProps = PropsWithChildren & {
  kpi: KPI;
  currency: string;
};

const SalesTargetPopover: React.FC<SalesTargetPopoverProps> = ({
  children,
  kpi,
  currency,
}) => {
  const renderPopoverTitle = (): React.ReactElement => {
    const titleAndColorMap: Record<string, { title: string; color: string }> = {
      onTrack: { title: 'On Track', color: '#389E0D' },
      offTrack: { title: 'Off Track', color: '#F90' },
      critical: { title: 'Critical', color: '#F5222D' },
    };

    const key = takeActionBasedOnCurrentProgressKPI(kpi, {
      onTrack: {
        lowerLimitPercentage: KPI_PERCENTAGES_FOR_TARGETS.salesTargets.onTrack,
        action: () => 'onTrack',
      },
      offTrack: {
        lowerLimitPercentage: KPI_PERCENTAGES_FOR_TARGETS.salesTargets.offTrack,
        action: () => 'offTrack',
      },
      critical: {
        action: () => 'critical',
      },
    });

    const { title, color } =
      titleAndColorMap[key as keyof typeof titleAndColorMap];

    return (
      <Flex className="season-overview__popover-content" align="center" gap={8}>
        <div
          className="dot"
          style={{ background: color, display: 'inline-block' }}
        />
        <span>{title}</span>
      </Flex>
    );
  };

  const renderPopoverContent = (): React.ReactElement => (
    <Flex vertical className="season-overview__popover-content">
      <span className="season-overview__widget-text--helper text-white">
        Expected Progress:{' '}
      </span>
      <span className="season-overview__widget-text--helper text-white bold">
        {currency ?? ''} {formatCurrencyShortened(kpi?.expectedTarget || 0)}{' '}
      </span>
    </Flex>
  );

  return (
    <Popover
      title={renderPopoverTitle()}
      content={renderPopoverContent()}
      trigger="hover"
      color="#000"
      placement="topLeft"
    >
      <Button type="link" style={{ textAlign: 'left' }} className="p-0">
        {children}
      </Button>
    </Popover>
  );
};
export default SalesTargetPopover;
